module.exports = "<div ng-repeat=\"flightRecommendation in $ctrl.tripDetails.Flights track by flightRecommendation.Id\" ng-if=::$ctrl.isSeatmapAvailableForFlightRecommendation(flightRecommendation) kt-trip-traveller-allocation-recommendation=::flightRecommendation kt-trip-traveller-allocation-recommendation-is-hold=::$ctrl.isHold kt-trip-traveller-allocation-recommendation-selected-seats=$ctrl.selectedSeats kt-trip-traveller-allocation-recommendation-trip-details=$ctrl.tripDetails></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation.html
// module id = 3508
// module chunks = 0